namespace GeniuzPOS.Inventory {
    export interface LookupIcGrLookupRow {
        SysDocNo?: string;
        DocNo?: string;
        StockTo?: string;
    }

    export namespace LookupIcGrLookupRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.LookupIcGrLookup';
        export const lookupKey = 'Inventory.LookupIcGrLookup';

        export function getLookup(): Q.Lookup<LookupIcGrLookupRow> {
            return Q.getLookup<LookupIcGrLookupRow>('Inventory.LookupIcGrLookup');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            StockTo = "StockTo"
        }
    }
}
